import type { ReactNode } from 'react'

import { StoryListElementWithFormToggler } from '@/components/StoryListElement.tsx'
import { StoryInteractionProvider } from '@/contexts/StoryInteractionContext.tsx'

type Props = {
  title: string
  stories: Story[]
  children?: ReactNode
}

export const Panel = ({ title, stories, children }: Props) => {
  return (
    <div className="flex-1 flex flex-col overflow-auto gap-2 bg-surface-backgroundElevated rounded-xl p-2 pr-0.5 min-w-[520px]">
      <div className="font-EN-KR-heading3-bold h-8 flex items-center justify-between text-contents-primary">
        <h2>{title}</h2>
        {children}
      </div>
      <div className="flex-1 overflow-scroll tracker-scrollbar">
        {stories.length > 0 ? (
          <StoryInteractionProvider>
            <ul className="rounded-sm overflow-hidden flex flex-col gap-[1px]">
              {stories.map((story) => (
                <StoryListElementWithFormToggler key={story.id} story={story} />
              ))}
            </ul>
          </StoryInteractionProvider>
        ) : (
          <div className="font-EN-KR-body1-regular text-grey-700 flex justify-center items-center h-full">
            no matching stories found
          </div>
        )}
      </div>
    </div>
  )
}
